<div class="release-note-form">
  <form [formGroup]="releaseNoteForm">
    <div class="top-area">
      <mat-form-field>
        <input
          matInput
          [matDatepicker]="releaseDatePicker"
          placeholder="Datum auswählen"
          (click)="releaseDatePicker.open()"
          formControlName="releaseDate"
          readonly
        />
        <mat-datepicker-toggle matSuffix [for]="releaseDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #releaseDatePicker></mat-datepicker>
      </mat-form-field>
      <button class="btn btn-outline-primary preview" (click)="preview()">Vorschau</button>
    </div>
    <div class="mid-area">
      <mat-form-field class="description-mat-field">
        <textarea
          matInput
          class="release-description"
          value=""
          formControlName="notes"
          placeholder="Bitte geben Sie hier Ihren Text ein. Eingabe für nächsten Eintrag."
        >
        </textarea>
      </mat-form-field>
    </div>
    <div class="actions-area">
      <button *ngIf="isDraft" class="btn btn-outline-primary draft" (click)="draft()">Als Entwurf speichern</button>
      <button class="btn btn-outline-primary publish" (click)="publish()">Neuerungen veröffentlichen</button>
    </div>
  </form>
</div>
